import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

import { useI18n } from "./I18nContext";

// Tiny inline FR / EN picker for unauthenticated pages where the
// user can't reach Settings yet. Renders as a plain pill of text
// links so it disappears into the corner instead of competing with
// the page's CTAs. Active locale is shown in primary; the rest are
// secondText and become primary on hover.
export default function LocalePicker({ className = "" }) {
  const { locale, setLocale, locales } = useI18n();
  return (
    <div
      role="group"
      aria-label="Language"
      className={`inline-flex items-center gap-1 text-xs ${className}`}
    >
      <FontAwesomeIcon icon={faGlobe} className="text-secondText/70 mr-1" aria-hidden="true" />
      {locales.map((l, i) => {
        const active = l.id === locale;
        return (
          <span key={l.id} className="inline-flex items-center">
            {i > 0 ? (
              <span className="mx-1 text-secondText/40" aria-hidden="true">
                ·
              </span>
            ) : null}
            <button
              type="button"
              onClick={() => setLocale(l.id)}
              aria-pressed={active}
              className={`uppercase tracking-wider transition ${
                active
                  ? "text-primary font-semibold"
                  : "text-secondText hover:text-primary"
              }`}
            >
              {l.id.slice(0, 2)}
            </button>
          </span>
        );
      })}
    </div>
  );
}
